import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { StageReadinessRow } from '@/hooks/useDviStageReadiness';
import { pct } from './stageColors';

interface Props {
  rows: StageReadinessRow[];
  onSelect: (row: StageReadinessRow) => void;
}

export function WeakestComponentsPanel({ rows, onSelect }: Props) {
  const eligible = rows.filter((r) => r.total_samples >= 10);
  const lowest = [...eligible].sort((a, b) => a.component_accuracy - b.component_accuracy).slice(0, 5);
  const highestRej = [...eligible].sort((a, b) => b.rejection_rate - a.rejection_rate).slice(0, 5);
  const regressing = [...eligible].sort((a, b) => a.velocity_30d - b.velocity_30d).slice(0, 5);
  return (
    <Card>
      <CardHeader className="pb-2"><CardTitle className="text-sm">Weakest Components</CardTitle></CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
        <div>
          <div className="text-muted-foreground mb-1">Lowest accuracy</div>
          {lowest.map((r) => (
            <button key={`l-${r.component}-${r.condition_type}`} onClick={() => onSelect(r)} className="block text-left w-full hover:underline">
              {r.component} <span className="text-muted-foreground">· {pct(r.component_accuracy)}</span>
            </button>
          ))}
        </div>
        <div>
          <div className="text-muted-foreground mb-1">Highest rejection</div>
          {highestRej.map((r) => (
            <button key={`r-${r.component}-${r.condition_type}`} onClick={() => onSelect(r)} className="block text-left w-full hover:underline">
              {r.component} <span className="text-muted-foreground">· {pct(r.rejection_rate)}</span>
            </button>
          ))}
        </div>
        <div>
          <div className="text-muted-foreground mb-1">Recent regressions</div>
          {regressing.map((r) => (
            <button key={`g-${r.component}-${r.condition_type}`} onClick={() => onSelect(r)} className="block text-left w-full hover:underline">
              {r.component} <span className="text-muted-foreground">· {(r.velocity_30d * 100).toFixed(1)}%</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
